import { ComparisonRows } from './ComparisonRows';

export type ComparisonBarDatum = {
    groupLabel: string;
    groupSubLabel?: string;
    refLabel: string;
    refIndex: number;
    refColor: string;
    refTextColor: string;
    increase: number;
    decrease: number;
    /** The group's baseline volume over all its priced lines: the same on every reference's datum of the group. */
    baselineTotal: number;
    /** Baseline volume of the lines this reference was compared on, which its net percentage is relative to. */
    comparedBaselineTotal: number;
    refTotal: number;
    sourceRows: unknown[];
};

export type ComparisonBarChartProps = {
    data: ComparisonBarDatum[];
    formatValue?: (value: number) => string;
    onBarClick?: (datum: ComparisonBarDatum) => void;
    showNetAnnotation?: boolean;
    visibleRefIndices?: number[];
};

export function ComparisonBarChart(props: ComparisonBarChartProps) {
    return <ComparisonRows {...props} view="priceChanges" />;
}
